import React, { useEffect, useState } from 'react'
import './routeNew.scss'
import iconRoute from 'assets/icon-route.svg';
import iconTrophy from 'assets/icon-trophy.svg';
import Challenges from '../challenges/challenges';
import { IChallenges } from 'adapters/challenges.adapter';
import Loader from 'shared/src/components/atoms/loader/loader';

interface IRouteNewProps {
	challenges: IChallenges[] | null
}

const RouteNew = ({ challenges }: IRouteNewProps) => {
	return (
		<div className='route'>
			<header className="route-header">
				<img src={iconRoute} alt={"Marcadores de una ruta"} />
				<div className="route-header__text">
					<h3>Estás un paso más cerca de alcanzar tu propósito</h3>
					<p>Esta es la ruta que Comfama diseñó para ti</p>
				</div>
			</header>
			<div className="route-container">
				<section className="route-result">
					<div className="route-result__icon">
						<img src={iconTrophy} alt="Icono trofeo" />
					</div>
					<div className="route-result-container">
						<div className="route-line">
							<div className="route-line-point route-line-point__1"></div>
						</div>
						<div className="route-result-container__video">
							<iframe width="560" height="315" src="https://www.youtube.com/embed/k71N8kkqnxw?controls=0" title="Próposito" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
						</div>
						<div className="route-result-container__info">
							<h3>Resultado</h3>
							<>
							{challenges?.map((value, key)=>{
							if(key === 0) 
							return(
									<p>{value.description}</p>
								)
							})
							}
							</>
						</div>
					</div>
				</section>
				<section className="route-challenges">
					<div className='route-challenges__container'>
						<div className="route-challenges__header">
							<h3>Mi ruta</h3>
							<h4>Aquí empieza tu reto</h4>
						</div>
						<div className="route-challenges__sub-header">
							<p>Te invitamos a realizar esta ruta de contenidos que está construida especialmente para ti, según las necesidades que identificamos en tu diagnóstico.</p>
							<p>Aquí vas a aprender algunas técnicas y herramientas que te ayudarán a acercarte cada vez más a tu propósito.</p>
						</div>
						<div className="route-challenges-container">
							{challenges ?
								<Challenges challenges={challenges} />
								: <div className='route-challenges-loader'>
									<Loader />
								</div>
							}
							<div className="route-line-2">
								<div className="route-line-point route-line-point__2"></div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	)
}

export default RouteNew